export default {
  privateSubtitle: 'Do you want to send invites for this form?',
  publicSubtitle: 'Share this link with whoever you wanto to reply to this form',
  cancel: 'Not now',
  sendForm: 'Send form',
  shareLink: 'Sharing link'
}
